import React, { useState } from 'react';
import '../styles/ActionModal.css';
import { mockApiCall } from '../api/mockApi';

const ActionModal = ({ show, onClose }) => {
  const [idea, setIdea] = useState('');
  const [sampleInput, setSampleInput] = useState('');
  const [sampleOutput, setSampleOutput] = useState('');
  const [title, setTitle] = useState('');
  const [prompt, setPrompt] = useState('');
  const [testResult, setTestResult] = useState('');

  if (!show) return null;

  const generateTitle = () => {
    if (idea.trim()) {
      const words = idea.trim().split(/\s+/).slice(0, 5).join(' ');
      setTitle(words);
    }
  };

  const createPrompt = async () => {
    try {
      const response = await mockApiCall({
        parentNodeId: 'action',
        parentNodeContent: idea,
        parentNodeType: 'textNode',
        operation: 'create-action-prompt',
      });
      setPrompt(response.content || '');
    } catch (err) {
      console.error('Failed to create prompt', err);
    }
  };

  const testPrompt = async () => {
    try {
      const response = await mockApiCall({
        parentNodeId: 'action',
        parentNodeContent: `${prompt}\n${sampleInput}`,
        parentNodeType: 'promptNode',
        operation: 'test-action',
      });
      setTestResult(response.content || '');
    } catch (err) {
      console.error('Test failed', err);
    }
  };

  return (
    <div className="action-modal-overlay" onClick={onClose}>
      <div className="action-modal" onClick={e => e.stopPropagation()}>
        <h2>Create Custom Action</h2>
        <label>Action Idea</label>
        <textarea value={idea} onChange={e => setIdea(e.target.value)} />
        <button onClick={generateTitle}>Generate Title</button>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={e => setTitle(e.target.value)}
        />
        <label>Sample Input</label>
        <textarea value={sampleInput} onChange={e => setSampleInput(e.target.value)} />
        <label>Sample Output</label>
        <textarea value={sampleOutput} onChange={e => setSampleOutput(e.target.value)} />
        <label>Prompt</label>
        <textarea value={prompt} onChange={e => setPrompt(e.target.value)} />
        <div className="action-buttons">
          <button onClick={createPrompt}>Create Prompt</button>
          <button onClick={testPrompt}>Test</button>
          <button onClick={onClose}>Close</button>
        </div>
        {testResult && (
          <pre className="test-result">{testResult}</pre>
        )}
      </div>
    </div>
  );
};

export default ActionModal;
